import { AuthService } from "@/services/auth-service";

export async function fetchWithAuth(url: string, options: RequestInit = {}) {
  const headers = AuthService.getAuthHeaders();

  // If body is FormData, let the browser set the Content-Type header automatically.
  if (options.body instanceof FormData) {
    delete headers["Content-Type"];
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  });

  if (response.status === 401) {
    AuthService.removeToken();
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    throw new Error("Unauthorized");
  }

  return response;
}
